import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=431bf33e&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=431bf33e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431bf33e",
  null
  
)

export default component.exports